import React from "react";
import PropTypes from "prop-types";

/**
 * TextParagraph: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Renders a text paragraph with proper line breaks
 * converted from \n
 *
 * @param {*} props
 */
const TextParagraph = props => (
  <p>
    {props.content.split("\n").map((item, key) => (
      <span key={key}>
        {item}
        <br />
      </span>
    ))}
  </p>
);

TextParagraph.propTypes = {
  /**
   * content: String
   * Content string that is displayed in the paragraph
   */
  content: PropTypes.string.isRequired
};

export default TextParagraph;



// WEBPACK FOOTER //
// ./src/components/ui/TextParagraph.js